import { IntakeNoteComprehensiveFormType } from '../IntakeNoteComprehensiveFormSchema'

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends Record<string, unknown> ? DeepPartial<T[P]> : T[P]
}

export const getDefaultValues = (): DeepPartial<IntakeNoteComprehensiveFormType> => ({
  SERVICE_DELIVERY_AND_COMPLIANCE: {
    CONFIRM_SERVICE_PROVIDED_VIA_TELEHEALTH: true,
    CONFIRM_INTAKE_TIME_AND_LOCATION: true,
    CONFIRM_SERVICE_PROVIDED_VIA_HIPAA_COMPLIANT_SOFTWARE: true,
  },
  ACCESSIBILITY_NEEDS: {
    NON_ENGLISH_SPEAKING: false,
    PROVIDE_INTERPRETIVE_SERVICES: false,
    CULTURAL_CONSIDERATIONS: 'reports_no',
    ACCESS_ISSUES: 'reports_no',
  },
  REASON_FOR_SEEKING_TREATMENT: {
    FUNCTIONAL_IMPAIRMENTS: {
      DIFFICULTY_MEETING_EXPECTATIONS: false,
      STRUGGLE_WITH_RELATIONSHIPS: false,
      NEGLECT_OF_PERSONAL_NEEDS: false,
      DIFFICULTY_IN_SLEEP: false,
      CHANGE_IN_APPETITE_OR_WEIGHT: false,
      IMPAIRED_COGNITIVE_FUNCTIONING: false,
      VOLATILE_MOOD_RESPONSES: false,
      DIFFICULTY_MANAGING_TASKS: false,
      LOSS_OF_INTEREST: false,
    },
  },
  MENTAL_HEALTH_TREATMENT_HISTORY: {
    SEEN_MENTAL_HEALTH_PROFESSIONAL_IN_PAST: false,
    HOSPITALIZED_FOR_MENTAL_HEALTH: false,
    HISTORY_OF_TRAUMA: 'reports_no',
  },
  RISK_ASSESSMENT: {
    BASE: {
      DENY_SI_SIB_SA_HI: false,
      SI_WITH_INTENT_PLAN_CRISIS_INITIATED: false,
      OTHER: false,
    },
    PROTECTIVE_FACTORS_IDENTIFIED: {
      STRONG_SOCIAL_SUPPORT: false,
      ENGAGEMENT_IN_THERAPY: false,
      COPING_SKILLS: false,
      FUTURE_ORIENTED_THINKING: false,
      MOTIVITED_FOR_TREATMENT: false,
      RELIGIOUS_BELIEFS: false,
      OTHER: false,
    },
    NEXT_STEPS: {
      SAFETY_PLAN_REVIEWED_EMAILLED: false,
      SAFETY_PLAN_DOCUMENTED_IN_RECORD: false,
      LAW_ENFORCEMENT_OR_EMERGENCY_CONTACT_NOTIFIED: false,
      NO_FURTHER_ASSISTANCE_NEEDED: false,
    },
  },
  BIOPYCHOSOCIAL_EVALUATION: {
    ALLERGIES: 'reports_no',
    MEDICAL_CONDITIONS: 'reports_no',
    MEDICATIONS: 'reports_no',
    FAMILY_HISTORY: 'reports_no',
    SUBSTANCE_ABUSE: {
      TOBACCO: 'NONE',
      ALCOHOL: 'NONE',
      MARIJUANA: 'NONE',
      NON_PRESCRIBED_DRUGS: 'NONE',
      OTHER_RECREATIONAL_DRUGS: 'NONE',
      REPORTS_INTEREST_TO_REDUCE_USE: false,
      REPORTS_RECEIVING_SUPPORT: false,
    },
  },
  MENTAL_STATUS_EXAMINATION: {
    APPEARANCE: 'NEAT',
    SPEECH: 'NORMAL',
    EYE_CONTACT: 'NORMAL',
    MOTOR_ACTIVITY: 'NORMAL',
    AFFECT: 'FULL',
    MOOD: 'EUTHYMIC',
    ORIENTATION_IMPAIRMENT: 'NONE',
    MEMORY_IMPAIRMENT: 'NONE',
    ATTENTION: 'NORMAL',
    HALLUCINATIONS: 'NONE',
    DELUSIONS: 'NONE',
    BEHAVIOR: 'COOPERATIVE',
    INSIGHT_JUDGMENT: 'GOOD',
  },
  ELIGIBILITY: {
    ELIGIBLE_FOR_PROGRAM_ENROLLMENT: false,
    NOT_ELIGIBLE_FOR_PROGRAM_ENROLLMENT: false,
    PARTICIPANT_DECLINES_ENROLLMENT: false,
  },
  REVIEWED_CONFIDENTIALITY_AND_EXPECTATIONS: false,
})
